import { render, staticRenderFns } from "./eventGrid.vue?vue&type=template&id=79d2b7bc&scoped=true&"
import script from "./eventGrid.vue?vue&type=script&lang=js&"
export * from "./eventGrid.vue?vue&type=script&lang=js&"
import style0 from "./eventGrid.vue?vue&type=style&index=0&id=79d2b7bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d2b7bc",
  null
  
)

export default component.exports